import { Injectable, ErrorHandler } from "@angular/core";

import { LoggerService } from "#core/services/logger.service";

/**
 * Error Handler
 * A quick indication for Angular that a new release was deployed is a chunk error
 * these errors occur due to hashing of chunck changes after a build. To fix and smooth
 * out deployments we do an automatic hard reload for the user when these errors are detected.
 *
 * Sources:
 * https://medium.com/@kamrankhatti/angular-lazy-routes-loading-chunk-failed-42b16c22a377
 * https://stackoverflow.com/questions/2099201/javascript-hard-refresh-of-current-page
 * http://jsfiddle.net/yp47mx2o/6/
 */
@Injectable()
export class CacheErrorInterceptor implements ErrorHandler {
    constructor(private loggerService: LoggerService) {}

    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;

        if (chunkFailedMessage.test(error.message)) {
            if (!!(<any>window).chrome && !!(<any>window).chrome.webstore) {
                // chrome doesn't accept the `true` boolean for hard refreshes so we have to reload manually
                (<any>window).location.href = (<any>window).location.href;
            } else {
                // all other browsers accept the true flag for hard refreshes
                (<any>window).location.reload();
            }
        } else {
            // Send error off to the logger if not local dev
            this.loggerService.cacheMessage({
                error: error,
                breadcrumb: location.pathname
            });

            // Print error in console
            console.error(error);
        }
    }
}
